<template>
  <div>
    <el-dialog
        :before-close="handleClose"
        :visible.sync="isAddStudentUpdateAlbumDialog"
        :show-close="true"
        :close-on-click-modal="false"
        width="70%"
        :top="'100px'"
        class="apply_kid_dialog album-studio-picker"
    >
      <template #title>
        <div class="title_dialog">
          <i class="el-icon-user-solid" />
          <span>Danh sách học sinh</span>
        </div>
        <p class="album-dialog-description">Chọn lớp, trạng thái và tìm học sinh để xác nhận phạm vi hiển thị album.</p>
      </template>

      <div class="body_dialog">
        <div class="section_filter">
          <el-row type="flex" :gutter="12">
            <el-col :span="8">
              <el-select
                  popper-class="album-studio-popper"
                  style="width: 100%"
                  v-model="classesApply"
                  multiple
                  filterable
                  allow-create
                  default-first-option
                  @change="handleChangeFilter"
                  placeholder="Chọn lớp"
                  aria-label="Chọn lớp học"
              >
                <el-option
                    v-for="(item, index) in listClass"
                    :key="index"
                    :label="item.className"
                    :value="item.id">
                </el-option>
              </el-select>
            </el-col>

            <el-col :span="8">
              <el-select
                  v-model="statusKids"
                  popper-class="album-studio-popper"
                  style="width: 100%"
                  placeholder="Trạng thái học sinh"
                  aria-label="Trạng thái học sinh"
                  @change="handleChangeFilter"
              >
                <el-option label="Tất cả trạng thái" value="" />
                <el-option
                    v-for="status in ['STUDYING', 'STUDY_WAIT', 'RESERVE', 'LEAVE_SCHOOL', 'OUT_SCHOOL']"
                    :key="status"
                    :label="parseKidStatusVietnamese(status)"
                    :value="status"
                />
              </el-select>
            </el-col>

            <el-col :span="8" v-if="classesApply.length > 0">
              <el-input
                  :clearable="true"
                  style="width: 100%"
                  placeholder="Nhập tên học sinh"
                  v-model="nameKids"
                  @change="handleChangeFilter(classesApply)"
                  @clear="handleChangeFilter(classesApply)"
                  aria-label="Tìm kiếm theo tên học sinh"
              >
                <template #append>
                  <el-button
                      icon="el-icon-search"
                      @click="handleChangeFilter(classesApply)"
                      aria-label="Tìm kiếm"
                  ></el-button>
                </template>
              </el-input>
            </el-col>
          </el-row>
        </div>

        <div :class="kidsDataFilter.length === 0 ? 'wrap_data no_data' : 'wrap_data'">
          <div v-if="kidsDataFilter.length > 0">
            <div class="select-all-box">
              <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">
                Tất cả
              </el-checkbox>
              <span class="album-picker-count">{{ idKidApply.length }} học sinh đã chọn</span>
            </div>
            <div class="data-scroll-container">
              <div v-for="(item) in kidsDataFilter" :key="item.idClass">
                <el-divider content-position="left">
                  <div>
                    <i class="el-icon-star-on"/>
                    <span class="title_group">{{ item.className }}</span>
                  </div>
                </el-divider>
                <el-checkbox-group v-model="idKidApply">
                  <el-checkbox
                      class="student-checkbox"
                      :title="kid.kidsName + ' - ' + kid.className"
                      v-for="(kid) in item.students"
                      :label="kid.idKid" :key="kid.idKid"
                  >
                    <span class="album-picker-student-name">{{ kid.kidsName }}</span>
                    <small class="album-picker-student-meta">{{ parseKidStatusVietnamese(kid.statusKids) }} · {{ kid.className }}</small>
                  </el-checkbox>
                </el-checkbox-group>
              </div>
            </div>
          </div>

          <div v-else class="no_data">
            <i class="el-icon-warning-outline"/>
            <span>Không có dữ liệu</span>
          </div>
        </div>
      </div>

      <template #footer>
        <div class="dialog-footer">
          <Phase2ActionButton @click="handleClose" type="default" size="small" icon="el-icon-circle-close">
            Hủy bỏ
          </Phase2ActionButton>

          <Phase2ActionButton type="primary" size="small" icon="el-icon-circle-check" @click="handleSaveForm()">
            Xác nhận
          </Phase2ActionButton>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import "./styles/album-studio.scss";
import SurveyForm from "@/services/SurveyForm";
import {mapState} from "vuex";
import parseInfoKidVietnameseMixin from "@/global/mixinKid/parseInfoKidVietnamese.mixin";
import Phase2ActionButton from "@/components/common/phase2/Phase2ActionButton.vue";

export default {
  components: {
    Phase2ActionButton,
  },
  props: {
    isAddStudentUpdateAlbumDialog: {
      type: Boolean,
      default: () => false
    },
    getAppTypeUserLogin: {
      type: String,
      default: () => "school"
    },
    kidsInSchool: {
      type: Array,
      default: () => []
    },
    initialClasses: {
      type: Array,
      default: () => []
    },
    initialKidIds: {
      type: Array,
      default: () => []
    },
  },
  computed: {
    ...mapState('classStore', ['classListCommon']),
    ...mapState('classStore', ['classInTeacher']),
    listClass() {
      if (this.$props.getAppTypeUserLogin === "plus") {
        return this.classListCommon;
      } else if (this.$props.getAppTypeUserLogin === "teacher") {
        return this.classInTeacher;
      }
      return [];
    },
  },
  data() {
    return {
      kidsInSchoolData: this.kidsInSchool.slice(),
      kidsDataFilter: [],
      classesApply: [],
      nameKids: "",
      statusKids: "STUDYING",
      idKidApply: [],
      checkAll: false,
      isIndeterminate: false
    };
  },

  watch: {
    isAddStudentUpdateAlbumDialog(value) {
      if (value) {
        this.initialDataApply(this.initialClasses, this.initialKidIds);
      }
    },
    kidsInSchool(newVal) {
      this.kidsInSchoolData = Array.isArray(newVal) ? newVal.slice() : [];
      if (this.isAddStudentUpdateAlbumDialog) {
        this.idKidApply = this.normalizeKidIds(this.idKidApply);
        this.handleChangeFilter(this.classesApply);
      }
    },
    classesApply(newVal, oldVal) {
      if (newVal.length < oldVal.length) {
        this.handleChangeKidsRemoveApply(newVal, oldVal);
      }
    },

    idKidApply() {
      this.handleChangeCheckApply();
    },

    kidsDataFilter() {
      this.handleChangeCheckApply();
    }

  },

  mixins: [
    parseInfoKidVietnameseMixin
  ],

  created() {
    this.fetchKidsInSchool();
  },
  methods: {
    handleClose() {
      this.$emit("closeDialog");
      this.resetData();
    },

    handleChangeCheckApply() {
      const visibleIds = this.getDataIdKids(this.parseDataFilterId(this.kidsDataFilter));
      const selectedIds = new Set(this.idKidApply);
      const selectedCount = visibleIds.filter(id => selectedIds.has(id)).length;
      this.checkAll = visibleIds.length > 0 && selectedCount === visibleIds.length;
      this.isIndeterminate = selectedCount > 0 && selectedCount < visibleIds.length;
    },

    fetchKidsInSchool() {
      SurveyForm.getAllKidsSchool()
          .then((res) => {
            this.kidsInSchoolData = res.data.data;
            this.handleChangeFilter();
          })
          .catch((err) => {
            console.log(err);
          });
    },

    handleCheckAllChange(val) {
      const visibleIds = this.getDataIdKids(this.parseDataFilterId(this.kidsDataFilter));
      const visibleSet = new Set(visibleIds);
      this.idKidApply = val
          ? [...new Set([...this.idKidApply, ...visibleIds])]
          : this.idKidApply.filter(id => !visibleSet.has(id));
      this.handleChangeCheckApply();
    },

    parseDataFilterId(dataFilter) {
      return dataFilter.flatMap(classItem => classItem.students);
    },

    getDataIdKids(kids) {
      const idKids = [];
      kids.map(kid => idKids.push(kid.idKid));
      return idKids;
    },

    getDataKidsApply(idKids) {
      return this.kidsInSchoolData.filter(kid => idKids.includes(kid.idKid));
    },

    handleChangeFilter() {
      const name = this.removeVietnameseTones(this.nameKids.trim());
      const result = this.kidsInSchoolData.filter(kid =>
          this.classesApply.includes(kid.idClass)
          && (!this.statusKids || kid.statusKids === this.statusKids)
          && (!name || this.removeVietnameseTones(kid.kidsName).includes(name)));
      this.kidsDataFilter = this.groupKidsByIdClass(result);
    },

    groupKidsByIdClass(kids) {
      const groupedObj = {};

      kids.forEach(item => {
        if (!groupedObj[item.idClass]) {
          groupedObj[item.idClass] = {
            idClass: item.idClass,
            className: item.className,
            students: []
          };
        }
        groupedObj[item.idClass].students.push({
          idKid: item.idKid,
          kidsName: item.kidsName,
          statusKids: item.statusKids,
          idClass: item.idClass,
          className: item.className
        });
      });

      return Object.values(groupedObj);
    },

    removeVietnameseTones(str) {
      return str
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "")
          .replace(/đ/g, "d")
          .replace(/Đ/g, "D")
          .toLowerCase();
    },

    handleSaveForm() {
      const data = {
        classesApply: this.idKidApply.length === 0 ? [] : this.classesApply,
        kidsApply: this.getDataKidsApply(this.idKidApply),
      };

      this.$emit('confirmData', data);
      this.resetData();
    },

    initialDataApply(classes, kids) {
      this.statusKids = "STUDYING";
      this.nameKids = "";
      this.classesApply = Array.isArray(classes) ? [...classes] : [];
      // The detail API normalizes IDs to strings, while checkbox labels use
      // the numeric `kid.idKid`. Keep the v-model values in the label type so
      // Element UI can restore the checked state reliably.
      this.idKidApply = this.normalizeKidIds(kids);
      this.handleChangeFilter(this.classesApply);
    },

    normalizeKidIds(kids) {
      const availableIds = new Map((this.kidsInSchoolData || []).map((kid) => [
        String(kid.idKid),
        kid.idKid,
      ]));
      return (Array.isArray(kids) ? kids : [])
          .map((kid) => typeof kid === "object"
              ? (kid.idKid ?? kid.kidId ?? kid.id)
              : kid)
          .filter((kidId) => kidId != null && kidId !== "")
          .map((kidId) => availableIds.has(String(kidId))
              ? availableIds.get(String(kidId))
              : kidId);
    },

    resetData() {
      this.kidsDataFilter = [];
      this.classesApply = [];
      this.nameKids = "";
      this.statusKids = "STUDYING";
      this.checkAll = false;
      this.isIndeterminate = false;
    },

    handleChangeKidsRemoveApply(newVal, oldVal) {
      const removedClasses = oldVal.filter(value => !newVal.includes(value));
      const removedIds = new Set(this.kidsInSchoolData
          .filter(kid => removedClasses.includes(kid.idClass))
          .map(kid => kid.idKid));
      this.idKidApply = this.idKidApply.filter(id => !removedIds.has(id));
    },
  }
};
</script>
